module.exports = __webpack_public_path__ + "img/like.e9df9d00.svg";